const BRAND_REGISTRATION_CONSTANTS = {
  heading: "Brand Registration Form",
  subheading: "Fill In Information Below So We Can Help With Your Request.",
  requiredNote: "Fields marked with * are required",

  submitLabel: "Submit",
  submittingLabel: "Submitting…",

  termsUrl: "#",
  privacyUrl: "#",

  fields: [
    {
      name: "projectType",
      label: "Project Type (Multiple answer option)",
      type: "checkbox-group",
      required: true,
      options: ["New Build", "Renovation", "Replace / Add equipment"],
    },
    {
      name: "projectAs",
      label: "Project As",
      type: "select",
      required: true,
      placeholder: "Select Project As",
      options: [
        "Architect",
        "Developer",
        "Interior Designer",
        "Individual",
        "Others",
      ],
    },
    {
      name: "budgetRange",
      label: "Budget Range",
      type: "select",
      required: true,
      placeholder: "Select Budget Range",
      options: [
        "IDR18.000.000 – IDR30.000.000",
        "IDR30.000.000 – IDR60.000.000",
        "IDR60.000.000 – IDR100.000.000",
        "More than IDR100.000.000",
      ],
    },
    {
      name: "timelineProject",
      label: "Timeline Project",
      type: "select",
      required: true,
      placeholder: "Select Timeline Project",
      options: [
        "Soonest – 1 Month",
        "1 – 4 months",
        "4 – 8 Months",
        "> 8 Months",
      ],
    },
    {
      name: "projectLocation",
      label: "Project Location",
      type: "text",
      required: true,
      placeholder: "Enter Project Location",
    },
    {
      name: "customerName",
      label: "Customer Name",
      type: "text",
      required: true,
      placeholder: "Enter Name",
    },
    {
      name: "customerEmail",
      label: "Customer Email",
      type: "email",
      required: true,
      placeholder: "Enter Email ID",
    },
    {
      name: "phoneNumber",
      label: "Phone Number",
      type: "text",
      required: true,
      placeholder: "Enter Phone Number",
    },
    {
      name: "agreeTerms",
      type: "checkbox",
      required: true,
      label: "I agree to the Terms and Conditions and Privacy Policy",
    },
    {
      name: "agreeMarketing",
      type: "checkbox",
      label:
        "By providing my contact information, I agree to receive special offers...",
    },
  ],
};

export default BRAND_REGISTRATION_CONSTANTS;
